import requestv2 from "~/utils/http-v2";

const customerGroupApi = {
	get : async (id) => {
		const url = `v2/customer/group/${id}`;
		return await requestv2.get(url);
	},
	gets : async (params) => {
		const url = 'v2/customer/group';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/customer/group';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/customer/group/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/customer/group/${id}`;
		return await requestv2.delete(url);
	}
};

export default customerGroupApi;